import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { KendoDatePicker } from './date-picker';

export function KendoStringDatePicker({
  value,
  max,
  min,
  placeholder,
  skeleton,
  i18n,
  onChange,
  onError,
  dateMethodOptions,
  ariaLabelledby,
}) {
  const parser = i18n.dateParser(dateMethodOptions);
  const looseParser = nullableStringDate =>
    (nullableStringDate ? parser(nullableStringDate) : nullableStringDate);
  const formatter = i18n.dateFormatter(dateMethodOptions);
  const looseFormatter = nullableDate =>
    (nullableDate ? formatter(nullableDate) : nullableDate);

  return (
    <KendoDatePicker
      value={looseParser(value)}
      max={looseParser(max)}
      min={looseParser(min)}
      placeholder={placeholder}
      skeleton={skeleton}
      i18n={i18n}
      onChange={(date) => {
        onChange(looseFormatter(date));
      }}
      onError={onError}
      ariaLabelledby={ariaLabelledby}
    />
  );
}

KendoStringDatePicker.propTypes = {
  value: PropTypes.string,
  max: PropTypes.string,
  min: PropTypes.string,
  placeholder: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf(['skeleton', 'raw']),
    }),
    PropTypes.string,
  ]),
  skeleton: PropTypes.string,
  i18n: PropTypes.shape({
    dateFormatter: PropTypes.func,
    dateParser: PropTypes.func,
    getLocale: PropTypes.func,
    getCldr: PropTypes.func,
  }).isRequired,
  onChange: PropTypes.func,
  onError: PropTypes.func,
  dateMethodOptions: PropTypes.shape({
    skeleton: PropTypes.string,
    date: PropTypes.oneOf(['full', 'long', 'medium', 'short']),
    raw: PropTypes.string,
    timeZone: PropTypes.string,
  }),
  ariaLabelledby: PropTypes.string,
};

KendoStringDatePicker.defaultProps = {
  value: null,
  max: undefined,
  min: undefined,
  placeholder: null,
  skeleton: 'yMd',
  onChange: _.noop,
  onError: _.noop,
  dateMethodOptions: {},
  ariaLabelledby: undefined,
};
